import { render, staticRenderFns } from "./App.vue?vue&type=template&id=553b0501"
var script = {}
import style0 from "./App.vue?vue&type=style&index=0&id=553b0501&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_24c34b177a67bdab664b1ded2c59e9ec/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports